import { render, staticRenderFns } from "./VCompliance.vue?vue&type=template&id=a32ed6fc"
import script from "./VCompliance.vue?vue&type=script&lang=js"
export * from "./VCompliance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports